export const cellMinWidth = 80;
export const cellMaxWidth = 800;
export const popChildCount = 4;
